module.exports = __webpack_public_path__ + "img/step2-5.8b3954b7.png";